// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/images/Hexagon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/images/AI_Marketplace_Logo_en.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconContainer {
  background-clip: border-box;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 2000px auto;
  background-position: -1663px -568px;
  padding-top: 80px;
  padding-right: 140px;
  padding-bottom: 200px;
  float: left;
  z-index: 0;
  position: absolute;
}

@media screen and (min-width: 1500px) {
.menusList{
    width: 100%;
}
}

@media screen and (min-width: 1500px) {
.menuitems{
    left: 100px;
}
}

@media screen and (min-width: 1700px) {
.menuitems{
    left: 250px;
}
}

@media screen and (min-width: 1900px) {
.menuitems{
    left: 350px;
}
}

@media screen and (min-width: 1900px) {
.menuitems{
    left: 20%;
}
}

@media screen and (min-width: 2100px) {
.menuitems{
    left: 30%;
}
}

@media screen and (max-width: 1500px) {
  .iconContainer{
     padding-top: 135px;
     background-position: -1663px -507px;
  }
  }

.iconLink {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: auto 110px;
  width: 176px;
  height: 110px;
  margin-left: 20px;
  display: block;
}


.menuPad {
padding-left: 400px;

}

.menuitems {
position: relative;
align-items: center;
}

.menusList {
border: 1px solid;
z-index: 1;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #222F37;
  position: fixed;
  top: 0;
  width: 100%;
}

.menuItem {
  float: left;
  display: block;
  color: #FFFFFF99;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 19.2px;
}

.menuItem:hover:not(.active) {
  background-color: #111;
  cursor: pointer;
}

.active {
  background-color: #04AA6D;
  cursor: pointer;
}


.menusList button {
  border: solid;
  border-color: #d50c2f;
  border-radius: 25px;
  border-width: 1px;
  background-color: #d50c2f;
  color: white;
  display: block;
  margin: auto;
  margin-top: 20px;
  width: 80px;
}

.listheading {
  position: absolute;
 margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/styles/header.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yDAAgD;EAChD,4BAA4B;EAC5B,4BAA4B;EAC5B,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;AACA;IACI,WAAW;AACf;AACA;;AAEA;AACA;IACI,WAAW;AACf;AACA;;AAEA;AACA;IACI,WAAW;AACf;AACA;;AAEA;AACA;IACI,WAAW;AACf;AACA;;AAEA;AACA;IACI,SAAS;AACb;AACA;;AAEA;AACA;IACI,SAAS;AACb;AACA;;AAEA;EACE;KACG,kBAAkB;KAClB,mCAAmC;EACtC;EACA;;AAEF;EACE,yDAA+D;EAC/D,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;AACA,mBAAmB;;AAEnB;;AAEA;AACA,kBAAkB;AAClB,mBAAmB;AACnB;;AAEA;AACA,iBAAiB;AACjB,UAAU;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;CACnB,iBAAiB;AAClB","sourcesContent":[".iconContainer {\n  background-clip: border-box;\n  background-image: url(\"/src/images/Hexagon.svg\");\n  background-repeat: no-repeat;\n  background-size: 2000px auto;\n  background-position: -1663px -568px;\n  padding-top: 80px;\n  padding-right: 140px;\n  padding-bottom: 200px;\n  float: left;\n  z-index: 0;\n  position: absolute;\n}\n\n@media screen and (min-width: 1500px) {\n.menusList{\n    width: 100%;\n}\n}\n\n@media screen and (min-width: 1500px) {\n.menuitems{\n    left: 100px;\n}\n}\n\n@media screen and (min-width: 1700px) {\n.menuitems{\n    left: 250px;\n}\n}\n\n@media screen and (min-width: 1900px) {\n.menuitems{\n    left: 350px;\n}\n}\n\n@media screen and (min-width: 1900px) {\n.menuitems{\n    left: 20%;\n}\n}\n\n@media screen and (min-width: 2100px) {\n.menuitems{\n    left: 30%;\n}\n}\n\n@media screen and (max-width: 1500px) {\n  .iconContainer{\n     padding-top: 135px;\n     background-position: -1663px -507px;\n  }\n  }\n\n.iconLink {\n  background-image: url(\"/src/images/AI_Marketplace_Logo_en.png\");\n  background-size: auto 110px;\n  width: 176px;\n  height: 110px;\n  margin-left: 20px;\n  display: block;\n}\n\n\n.menuPad {\npadding-left: 400px;\n\n}\n\n.menuitems {\nposition: relative;\nalign-items: center;\n}\n\n.menusList {\nborder: 1px solid;\nz-index: 1;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background-color: #222F37;\n  position: fixed;\n  top: 0;\n  width: 100%;\n}\n\n.menuItem {\n  float: left;\n  display: block;\n  color: #FFFFFF99;\n  text-align: center;\n  padding: 14px 16px;\n  text-decoration: none;\n  font-size: 19.2px;\n}\n\n.menuItem:hover:not(.active) {\n  background-color: #111;\n  cursor: pointer;\n}\n\n.active {\n  background-color: #04AA6D;\n  cursor: pointer;\n}\n\n\n.menusList button {\n  border: solid;\n  border-color: #d50c2f;\n  border-radius: 25px;\n  border-width: 1px;\n  background-color: #d50c2f;\n  color: white;\n  display: block;\n  margin: auto;\n  margin-top: 20px;\n  width: 80px;\n}\n\n.listheading {\n  position: absolute;\n margin-left: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
